import { render, staticRenderFns } from "./LandtrustStatistics.vue?vue&type=template&id=65da2d96&scoped=true"
import script from "./LandtrustStatistics.vue?vue&type=script&lang=js"
export * from "./LandtrustStatistics.vue?vue&type=script&lang=js"
import style0 from "./LandtrustStatistics.vue?vue&type=style&index=0&id=65da2d96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65da2d96",
  null
  
)

export default component.exports